export const byteToMb = (byte: number, accuracy?: number) => parseFloat((byte / 1024 / 1024).toFixed(accuracy || 0))

export const byteToKb = (byte: number, accuracy: number) => parseFloat((byte / 1024).toFixed(accuracy))
